module.exports = __webpack_public_path__ + "static/media/2.61dfb09b.png";